<app-patient-info [heading]="Item"></app-patient-info>
<p-table
  *ngIf="vitals"
  [responsive]="true"
  [columns]="selectedColumns"
  [value]="vitals.data"
  selectionMode="single"
  dataKey="date"
  [resetPageOnSort]="false"
  [lazy]="false"
  [rows]="rows"
  [paginator]="showRecords"
  (sortFunction)="customSort($event, 1)"
  [customSort]="true"
>
  <ng-template pTemplate="caption">
    <div class="grid col-12 pb-0" style="padding: 0px !important">
      <div class="col-12 md:col-2 pb-0">
        <p-multiSelect
          [options]="cols"
          [(ngModel)]="selectedColumns"
          optionLabel="header"
          contenteditable="false"
          [showToggleAll]="true"
          selectedItemsLabel="{0} columns selected"
          [style]="{ minWidth: '200px' }"
          class="multiselect-custom-virtual-scroll custom-ms"
          placeholder="Choose Columns"
        ></p-multiSelect>
      </div>
      <div
        class="col-12 md:col-5 pb-0"
        style="display: flex; justify-content: right"
      >
        <h5 style="margin-right: 10px; padding-top: 12px">Change Units</h5>
        <p-inputSwitch
          (onChange)="toggleActivation($event)"
          onLabel="On"
          offLabel="Off"
          class="custom-switch pt-2 alignRight"
        ></p-inputSwitch>
      </div>
      <div
        class="col-12 md:col-5 pt-3 pb-0 alignRight"
        style="justify-content: right"
      >
        <button
          pButton
          type="button"
          icon="pi pi-chart-bar"
          label="Growth Charts"
          class="ui-button-plain"
          style="
            background-color: #141b58;
            color: snow;
            max-width: 150px;
            height: 34px;
            max-height: 34px;
          "
          (click)="showGrowthCharts()"
        ></button
        >&nbsp;
        <button
          pButton
          type="button"
          icon="pi pi-print"
          label="Print"
          class="p-button-plain"
          (click)="printVitals()"
          title="Print Vitals"
          *ngIf="setPrintFlag"
        ></button
        >&nbsp; &nbsp;
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns style="padding-top">
    <tr *ngIf="showRecords == true">
      <th *ngFor="let col of columns" [pSortableColumn]="col.field">
        {{ col.header }}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>

      <th></th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-rowData
    let-columns="columns"
    let-i="rowIndex"
  >
    <tr [pSelectableRow]="rowData">
      <td *ngFor="let col of columns">
        <div
          *ngIf="
            col.header == 'BMI11';
            then nested_object_content;
            else normal_content
          "
        ></div>

        <ng-template #nested_object_content>
            <span class="p-badge" [ngClass]="getBMIClass(+rowData[col.field])">
                {{ rowData[col.field] }}
            </span>
        </ng-template>
        <ng-template #normal_content>
          <!--<span class="column-title">{{col.header}}</span>-->
          {{ rowData[col.field] }}
        </ng-template>
      </td>

      <td>
        <button
          pButton
          type="button"
          icon="pi pi-chart-line"
          class="p-button-info"
          style="font-size: 0.7em"
          (click)="displaychartstypepopup = true"
        ></button>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <div class="w-12 bg-white">
      <div class="" style="text-align: center">
        <img
          _ngcontent-ng-c683320295=""
          class="profile-image"
          style="border-radius: 50%; width: 10rem; padding-top: 1rem"
          src="assets/imagesNew/table_error.png"
        />
      </div>
      <hr style="margin-bottom: 0.5rem" />
      <div class=""
           style="text-align: center; font-size: larger; color: #1d428f">
          <i>No records found</i>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="paginatorleft" let-state>
      <span *ngIf="state.totalRecords > pageSize">
          Showing {{ state.page * state.rows + 1 }} to
          {{ state.rows * (state.page + 1) }} of {{ state.totalRecords }} records.
      </span>
  </ng-template>
</p-table>

<p-dialog
  [(visible)]="displaypopup"
  [draggable]="true"
  [style]="{ width: '800px' }"
  [modal]="true"
  positionType="absolute"
  [maximizable]="true"
>
  <p-header>
    {{ popupheader }}
  </p-header>

  <div class="grid" *ngIf="graphdata">
    <div class="col-12 p-md12">
      <p-chart type="line" [data]="graphdata"></p-chart>
    </div>
  </div>

  <p-footer style="display: flex; justify-content: center">
    <button
      pButton
      type="button"
      icon="ui-icon-close"
      (click)="displaypopup = false"
      label="Cancel"
      class="ui-button-secondary"
    ></button>
  </p-footer>
</p-dialog>

<p-dialog
  [(visible)]="displaychartstypepopup"
  [draggable]="true"
  [modal]="true"
  positionType="absolute"
  [maximizable]="true"
>
  <p-header> Chart Type </p-header>

  <div class="grid">
    <div class="col-12 p-md12">
      <p-panel header="Select Chart Type:">
        <p-radioButton
          name="clinical"
          [(ngModel)]="clinical"
          value="Height"
          label="Height "
          inputId="rbHeight"
          (click)="setSelection('Height')"
        ></p-radioButton        >&nbsp;

        <p-radioButton
          name="clinical"
          [(ngModel)]="clinical"
          value="Weight"
          label="Weight"
          inputId="rbWeight"
          (click)="setSelection('Weight')"
        ></p-radioButton>


          &nbsp;
        <p-radioButton
          name="clinical"
          [(ngModel)]="clinical"
          value="BP"
          label="BP"
          inputId="rbBP"
          (click)="setSelection('BP')"
        ></p-radioButton
        >&nbsp;

        <p-radioButton
          name="clinical"
          [(ngModel)]="clinical"
          value="Pulse"
          label="Pulse"
          inputId="rbPulse"
          (click)="setSelection('Pulse')"
        ></p-radioButton
        >&nbsp;
        <p-radioButton
          name="clinical"
          [(ngModel)]="clinical"
          value="Temp"
          label="Temp"
          inputId="rbTemp"
          (click)="setSelection('Temp')"
        ></p-radioButton
        >&nbsp;

        <p-radioButton
          name="clinical"
          [(ngModel)]="clinical"
          value="Resp"
          label="Resp"
          inputId="rbResp"
          (click)="setSelection('Resp')"
        ></p-radioButton
        >&nbsp;
        <p-radioButton
          name="clinical"
          [(ngModel)]="clinical"
          value="Spo2"
          label="Spo2"
          inputId="rbSpo2"
          (click)="setSelection('Spo2')"
        ></p-radioButton
        >&nbsp;

        <p-radioButton
          name="clinical"
          [(ngModel)]="clinical"
          value="HeadCirc"
          label="HeadCirc"
          inputId="rbHeadCirc"
          (click)="setSelection('HeadCirc')"
        ></p-radioButton
        >&nbsp;
      </p-panel>
    </div>
  </div>

  <p-footer style="display: flex; justify-content: center">
    <button
      pButton
      type="button"
      icon="pi pi-times-circle"
      (click)="resetSelection()"
      label="Cancel"
      class="ui-button-secondary ml-1"
    ></button>
  </p-footer>
</p-dialog>

<!--GrowthCharts -->

<p-dialog
  [(visible)]="displayGrowthChartPopUp"
  [draggable]="true"
  [modal]="true"
  positionType="absolute"
  [maximizable]="true"
>
  <p-header> Select Chart Type </p-header>

  <div class="grid">
    <div class="col-12">
      <div *ngIf="!patientGender" style="font-size: 14px !important">
        <div class="row pb-3">
          <p-radioButton
            name="growthcharttype"
            [(ngModel)]="growthcharttype"
            value="G_3"
            label="2 to 20 years: Girls, Stature-for-age and Weight-for-age percentiles "
            inputId="rbprovby_G_3"
            (onClick)="setGrowthchartType('G_3')"
          ></p-radioButton
          >&nbsp;
        </div>

        <div class="row pb-3">
          <p-radioButton
            name="growthcharttype"
            [(ngModel)]="growthcharttype"
            value="G_4"
            label="2 to 20 years: Girls, Body mass index-for-age percentiles"
            inputId="rbresourceby_G_4"
            (onClick)="setGrowthchartType('G_4')"
          ></p-radioButton
          >&nbsp;
        </div>

        <div class="row pb-3">
          <p-radioButton
            name="growthcharttype"
            [(ngModel)]="growthcharttype"
            value="G_5"
            label="Weight-for-stature percentiles: Girls"
            inputId="rbprovby_G_5"
            (onClick)="setGrowthchartType('G_5')"
          ></p-radioButton
          >&nbsp;
        </div>
        <div class="row pb-3">
          <p-radioButton
            name="growthcharttype"
            [(ngModel)]="growthcharttype"
            value="G_1"
            label="Birth to 36 months: Girls, Length-for-age and Weight-for-age percentiles"
            inputId="rbprovby_G_1"
            (onClick)="setGrowthchartType('G_1')"
          ></p-radioButton
          >&nbsp;
        </div>
        <div class="row pb-3">
          <p-radioButton
            name="growthcharttype"
            [(ngModel)]="growthcharttype"
            value="G_2"
            label="Birth to 36 months: Girls, Head circumference-for-age and Weight-for-length percentiles"
            inputId="rbprovby_G_2"
            (onClick)="setGrowthchartType('G_2')"
          ></p-radioButton
          >&nbsp;
        </div>
      </div>

      <div *ngIf="patientGender" style="font-size: 14px !important">
        <div class="row pb-3">
          <p-radioButton
            name="growthcharttype"
            [(ngModel)]="growthcharttype"
            value="B_3"
            label="2 to 20 years: Boys, Stature-for-age and Weight-for-age percentiles"
            inputId="rbprovby_B_3"
            (onClick)="setGrowthchartType('B_3')"
          ></p-radioButton
          >&nbsp;
        </div>
        <div class="row pb-3">
          <p-radioButton
            name="growthcharttype"
            [(ngModel)]="growthcharttype"
            value="B_4"
            label="2 to 20 years: Boys, Body mass index-for-age percentiles"
            inputId="rbresourceby_B_4"
            (onClick)="setGrowthchartType('B_4')"
          ></p-radioButton
          >&nbsp;
        </div>
        <div class="row pb-3">
          <p-radioButton
            name="growthcharttype"
            [(ngModel)]="growthcharttype"
            value="B_5"
            label="Weight-for-stature percentiles: Boys"
            inputId="rbprovby_B_5"
            (onClick)="setGrowthchartType('B_5')"
          ></p-radioButton
          >&nbsp;
        </div>
        <div class="row pb-3">
          <p-radioButton
            name="growthcharttype"
            [(ngModel)]="growthcharttype"
            value="B_1"
            label="Birth to 36 months: Boys, Length-for-age and Weight-for-age percentiles"
            inputId="rbresourceby_B_1"
            (onClick)="setGrowthchartType('B_1')"
          ></p-radioButton
          >&nbsp;
        </div>
        <div class="row pb-3">
          <p-radioButton
            name="growthcharttype"
            [(ngModel)]="growthcharttype"
            value="B_2"
            label="Birth to 36 months: Boys, Head circumference-for-age and Weight-for-length percentiles"
            inputId="rbprovby_B_2"
            (onClick)="setGrowthchartType('B_2')"
          ></p-radioButton
          >&nbsp;
        </div>
      </div>
    </div>
  </div>
  <hr />

  <div style="display: flex; justify-content: center">
    <button
      pButton
      type="button"
      icon="pi pi-chart-line"
      (click)="createGrowthchartType()"
      label="Done"
      class="p-button-plain BlueGradient mr-4"
      [disabled]="isButtonDisabled"
    ></button>
    <button
      pButton
      type="button"
      icon="pi pi-times"
      (click)="displayGrowthChartPopUp = false"
      label="Cancel"
      class="ui-button-plain GreyButton"
    ></button>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="growthChartPopUp"
  [draggable]="true"
  [modal]="true"
  positionType="absolute"
  [maximizable]="true"
>
  <p-header>
    &nbsp;&nbsp;<i class="pi pi-chart-bar"></i> Growth Chart.
  </p-header>

  <div class="grid" id="printGrowthChart">
    <div class="col-12 p-md12">
      <h3>{{ growthChartLabelDetails }}</h3>
    </div>
    <div class="col-12 p-md12">
      <img [src]="imageData" [style.width]="imageWidth" />
    </div>
  </div>

  <p-footer style="display: flex; justify-content: center">
    <div class="progress">
      <button
        pButton
        type="button"
        icon="pi pi-print"
        (click)="printGrowthChart()"
        label="Print"
        class="p-button-plain"
      ></button>

      <button
        pButton
        type="button"
        [icon]="zoomInOutIcon"
        (click)="zoomGrowthChart()"
        [label]="zoomInOutLable"
        class="p-button-plain"
      ></button>
    </div>
    <button
      pButton
      type="button"
      icon="pi pi-times"
      (click)="growthChartPopUp = false"
      label="Cancel"
      class="p-button-plain"
    ></button>
  </p-footer>
</p-dialog>

<!-- Print functionality  for Vitals List -->
<div class="panel table-responsive" id="PrintVitals_List" style="display: none">
  <div
    style="
      display: flex;
      background-color: #ffffff;
      margin-bottom: 1.5%;
      padding: 0.5%;
    "
  >
    <div
      style="
        display: flex;
        justify-content: left;
        align-items: center;
        width: 50%;
      "
    >
      <span>Vitals&nbsp;</span>
    </div>
    <div
      style="
        display: flex;
        justify-content: right;
        align-items: center;
        width: 50%;
      "
    >
      <span
        ><strong>{{ patientFullName }}</strong></span
      >
    </div>
  </div>

  <div
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0% 0% 0% 0%;
    "
  >
      <table style="width: 100%; border-collapse: collapse; border: 1px solid grey"
             id="Vitals_print_table_tbody">
          <thead style="
          background-color: #142066;
          border: 0px solid #808080;
          color: snow;
        ">
              <tr>
                  <th *ngFor="let col of _selectedColumns"
                      style="border: 1px solid #808080; text-align: left">
                      {{ col.header }}
                  </th>
              </tr>
          </thead>
          <tbody id="Vitals_print_table_tbody">
              <tr *ngFor="let item of vitals?.data" style="border: 1px solid #808080">
                  <td *ngFor="let col of _selectedColumns" style="text-align: left; border: 1px solid #808080;padding: 0.5% 0% 0.5% 0%;">
                      <ng-container *ngIf="col.header == 'BMI'; else normalContent">
                        <span [ngStyle]="getBMIStyle(+item[col.field])">
                              {{ item[col.field] }}
                          </span>

                      </ng-container>
                      <ng-template #normalContent>
                          {{ item[col.field] }}
                      </ng-template>
                  </td>
              </tr>
          </tbody>
      </table>
  </div>
  <div *ngIf="vitals?.data.length == 0"
       class="alert alert-warning"
       role="alert"
       style="text-align: center">
      <span class="glyphicon glyphicon-exclamation-sign"
            aria-hidden="true"></span>
      <span class="sr-only">Error:</span>
      <i>No records found</i>
  </div>
</div>
